<script>
import Base from '@/plans/ROOM_CONNECTOR/config/base';

export default {
  extends: Base,
  data() {
    return {
      showCycleAlert: true,
    }
  },
};
</script>
